<div
  class="flex justify-content-end width-100 align-items-center"
  *ngIf="dataSelectionPartes.length > 0 || dataSelectionPedidos.length > 0"
>
  <div
    *ngIf="dataSelectionPedidos.length > 0 || isCheckAllActivate"
    class="flex align-items-center"
  >
    <span class="font-bold fs-normal">
      {{
        isCheckAllActivate
          ? pageLength
          : headerChecked && isPartial
          ? pageLength === 0
            ? 0
            : pageLength - unSelectedEntities.length
          : selectedEntities.length
      }}
      pedido(s) selecionado(s)
    </span>
    &nbsp;
    <button
      pButton
      pRipple
      icon="pi pi-times-circle"
      class="p-button-icon p-button-danger p-button-sm p-button-text"
      label=""
      (click)="clearSelectionsValues()"
      pTooltip="Remover seleção"
    ></button>
  </div>
  <div *ngIf="dataSelectionPartes.length > 0" class="flex align-items-center">
    <span class="font-bold fs-normal">
      {{ dataSelectionPartes.length }} peça(s) selecionada(s)
    </span>
    &nbsp;
    <button
      pButton
      pRipple
      icon="pi pi-times-circle"
      class="p-button-icon p-button-danger p-button-sm p-button-text"
      label=""
      (click)="dataSelectionPartes = []"
      pTooltip="Remover seleção"
    ></button>
  </div>
</div>
<p-table
  #tablePedidos
  [value]="loading ? [] : monitorados"
  dataKey="numero"
  selectionMode="multiple"
  rowExpandMode="single"
  [(selection)]="dataSelectionPedidos"
  (selectionChange)="selectEntities($event)"
  (onRowUnselect)="unSelectRow($event)"
  [rowHover]="true"
  (onRowExpand)="expandedAction($event)"
  (onRowCollapse)="dataSelectionPartes = []"
  styleClass="p-datatable-customers mat-elevation-z5"
  [tableStyle]="{ 'min-width': '60rem' }"
>
  <ng-template pTemplate="header">
    <tr class="p-datatable-thead">
      <span class="item"></span>
      <th *ngIf="processo && processo.gerencia_partes" style="width: 3rem"></th>
      <th style="width: 3rem" *ngIf="!isOnlyMonitoramento">
        <mat-checkbox
          [checked]="
            selectedEntities.length !== 0 || isCheckAllActivate
              ? selectedEntities.length === pageLength || isCheckAllActivate
              : false
          "
          color="primary"
          [indeterminate]="
            selectedEntities.length !== 0 && !isCheckAllActivate
              ? selectedEntities.length !== pageLength && !isCheckAllActivate
              : false
          "
          (change)="headerChecboxAction($event)"
        ></mat-checkbox>
      </th>
      <th
        *ngFor="let col of columns"
        pResizableColumn
        [pSortableColumn]="col.sortable ? col.field_sortable : null"
      >
        <span *ngIf="!col.useBtnAction || isOnlyMonitoramento">{{
          col.header_name
        }}</span>
        <button
          pButton
          pRipple
          [pTooltip]="col.header_name"
          outlined
          rounded
          icon="pi pi-fw pi-ellipsis-v"
          severity="primary"
          iconPos="right"
          *ngIf="col.useBtnAction && !isOnlyMonitoramento"
          [matMenuTriggerFor]="menuAcoesGeral"
        ></button>
        <mat-menu #menuAcoesGeral="matMenu">
          <div class="flex flex-column justify-content-center width-100">
            <p-button
              *ngIf="
                validActionsPedidos.iniciar_producao_etapas &&
                !isOnlyMonitoramento
              "
              icon="pi pi-play-circle"
              iconPos="right"
              styleClass="width-100 p-button-help p-button-text p-button-rounded"
              label="Iniciar a produção das peças"
              (onClick)="onSendStartEtapa()"
              [disabled]="checkDataSelectionParaIniciarPecas()"
            ></p-button>
            <p-button
              *ngIf="
                validActionsPedidos.enviar_multiplas_pecas &&
                !isOnlyMonitoramento
              "
              icon="pi pi-send"
              iconPos="right"
              styleClass="width-100 p-button-primary p-button-text p-button-rounded"
              label="Enviar peças para uma etapa"
              [disabled]="checkDataSelectionParaConcluirPecas()"
              (onClick)="onSendEtapa()"
            ></p-button>
            <p-button
              *ngIf="
                validActionsPedidos.finalizar_multiplas_pecas &&
                !isOnlyMonitoramento
              "
              iconPos="right"
              icon="pi pi-check-circle"
              iconPos="right"
              styleClass="width-100 p-button-success p-button-text p-button-rounded"
              label="Finalizar as peças em andamento"
              [disabled]="checkDataSelectionParaFinalizarPecas()"
              (onClick)="onFinalizarEtapa()"
            ></p-button>
            <p-button
              *ngIf="
                validActionsPedidos.concluir_multiplas_pecas &&
                !isOnlyMonitoramento
              "
              icon="pi pi-thumbs-up"
              iconPos="right"
              styleClass="width-100 p-button-success p-button-text p-button-rounded"
              label="Concluir as peças do pedido"
              [disabled]="checkDataSelectionParaConcluirPecas()"
              (onClick)="onConclusion()"
            ></p-button>
            <p-button
              *ngIf="
                validActionsPedidos.iniciar_producao_processo &&
                !isOnlyMonitoramento &&
                processo &&
                !processo.gerencia_partes
              "
              icon="pi pi-play-circle"
              iconPos="right"
              (click)="onStartPedido.emit(null)"
              [disabled]="checkDataSelectionParaIniciarProcesso()"
              styleClass="width-100 p-button-help p-button-text p-button-rounded"
              label="Iniciar processo dos pedidos"
            ></p-button>
            <p-button
              *ngIf="
                validActionsPedidos.processo_seguinte && !isOnlyMonitoramento
              "
              icon="pi pi-send"
              iconPos="right"
              [disabled]="checkDataSelectionParaEncaminharProcesso()"
              (click)="onSendPedido.emit(null)"
              styleClass="width-100 p-button-primary p-button-text p-button-rounded"
              label="Enviar pedidos para um processo"
            ></p-button>
            <p-button
              *ngIf="
                validActionsPedidos.processo_finalizar && !isOnlyMonitoramento
              "
              icon="pi pi-check-circle"
              iconPos="right"
              [disabled]="checkDataSelectionParaFinalizarProcesso()"
              (click)="onGenerateFinalizarProcesso.emit(null)"
              styleClass="width-100 p-button-success p-button-text p-button-rounded"
              label="Finalizar processo de pedidos"
            ></p-button>
            <p-button
              *ngIf="
                validActionsPedidos.concluir_pedido && !isOnlyMonitoramento
              "
              icon="pi pi-thumbs-up"
              iconPos="right"
              [disabled]="checkDataSelectionParaConcluirPedidos()"
              (click)="onSendPedidoConcluido.emit(null)"
              styleClass="width-100 p-button-success p-button-text p-button-rounded"
              label="Concluir pedidos"
            ></p-button>
          </div>
        </mat-menu>
      </th>
      <th style="width: 3rem">
        <button
          pButton
          pRipple
          icon="pi pi-fw pi-cog"
          severity="info"
          rounded
          text
          (click)="openDialogReorderColumns()"
          pTooltip="Organizar colunas da tabela"
        ></button>
      </th>
    </tr>
  </ng-template>
  <ng-template
    pTemplate="body"
    let-element
    let-expanded="expanded"
    let-rowIndexPedido="rowIndex"
  >
    <tr
      class="p-datatable-tbody"
      [ngClass]="{ 'item-inative': !element.active }"
    >
      <span class="item"></span>
      <td
        [ngClass]="{ 'bg-black-alpha-30': expanded }"
        *ngIf="processo && processo.gerencia_partes"
      >
        <button
          type="button"
          pButton
          pRipple
          [pRowToggler]="element"
          class="p-button-text p-button-rounded p-button-plain"
          [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
        ></button>
      </td>
      <td
        [ngClass]="{ 'bg-black-alpha-30': expanded }"
        *ngIf="!isOnlyMonitoramento"
      >
        <p-tableCheckbox
          [value]="element"
          [disabled]="checkIsRowExpanded([element])"
        ></p-tableCheckbox>
      </td>
      <td
        [ngClass]="{ 'bg-black-alpha-30': expanded }"
        *ngFor="let col of columns"
      >
        <div *ngIf="col.useBtnAction">
          <p-button
            outlined
            rounded
            icon="pi pi-ellipsis-v"
            styleClass="p-button-primary p-button-text p-button-rounded"
            pTooltip="Ações no pedido"
            [matMenuTriggerFor]="menuAcoesPedido"
          ></p-button>
          <mat-menu #menuAcoesPedido="matMenu">
            <div class="flex flex-column justify-content-center width-100">
              <p-button
                *ngIf="
                  validActionsPedidos.iniciar_producao_processo &&
                  !isOnlyMonitoramento &&
                  processo &&
                  !processo.gerencia_partes
                "
                icon="pi pi-play-circle"
                iconPos="right"
                styleClass="width-100 p-button-help p-button-text p-button-rounded"
                label="Iniciar produção"
                (onClick)="onStartPedido.emit([element])"
                [disabled]="
                  element.is_processo_iniciado ||
                  !processo ||
                  statusProcesso !== 'AGUARDANDO'
                "
              ></p-button>
              <p-button
                *ngIf="
                  validActionsPedidos.processo_seguinte && !isOnlyMonitoramento
                "
                icon="pi pi-send"
                iconPos="right"
                styleClass="width-100 p-button-primary p-button-text p-button-rounded"
                label="Enviar para processo seguinte"
                [disabled]="
                  element.status !== 'CONCLUIDO_PARTES' ||
                  !element.is_processo_finalizado ||
                  statusProcesso !== 'FINALIZADO' ||
                  statusPedido !== 'CONCLUIDO_PARTES'
                "
                (onClick)="onSendPedido.emit([element])"
              ></p-button>
              <p-button
                *ngIf="
                  validActionsPedidos.processo_erro && !isOnlyMonitoramento
                "
                icon="pi pi-exclamation-triangle"
                iconPos="right"
                styleClass="width-100 p-button-danger p-button-text p-button-rounded"
                [label]="
                  element.has_erro_pendente
                    ? 'Visualizar erro do processo'
                    : 'Cadastrar erro no processo'
                "
                (onClick)="
                  onGenerateError.emit({ pedido: element, processoErro: true })
                "
                [disabled]="
                  (element.is_processo_finalizado ||
                    !element.is_processo_iniciado) &&
                  !element.has_erro_pendente
                "
              ></p-button>
              <p-button
                *ngIf="
                  validActionsPedidos.processo_finalizar && !isOnlyMonitoramento
                "
                icon="pi pi-check-circle"
                iconPos="right"
                styleClass="width-100 p-button-success p-button-text p-button-rounded"
                label="Finalizar processo em andamento"
                [disabled]="
                  element.status !== 'CONCLUIDO_PARTES' ||
                  element.is_processo_finalizado ||
                  statusProcesso !== 'EM_ANDAMENTO' ||
                  statusPedido !== 'CONCLUIDO_PARTES'
                "
                (onClick)="onGenerateFinalizarProcesso.emit([element])"
              ></p-button>
              <p-button
                *ngIf="
                  validActionsPedidos.iniciar_producao_etapas &&
                  !isOnlyMonitoramento
                "
                icon="pi pi-play-circle"
                iconPos="right"
                styleClass="width-100 p-button-help p-button-text p-button-rounded"
                label="Iniciar a produção das peças"
                (onClick)="onSendStartEtapa()"
                [disabled]="checkDataSelectionParaIniciar(element.id)"
              ></p-button>
              <p-button
                *ngIf="
                  validActionsPedidos.enviar_multiplas_pecas &&
                  !isOnlyMonitoramento
                "
                icon="pi pi-send"
                iconPos="right"
                styleClass="width-100 p-button-primary p-button-text p-button-rounded"
                label="Enviar peças para uma etapa"
                [disabled]="checkDataSelectionFinalizados(element.id)"
                (onClick)="onSendEtapa()"
              ></p-button>
              <p-button
                *ngIf="
                  validActionsPedidos.finalizar_multiplas_pecas &&
                  !isOnlyMonitoramento
                "
                iconPos="right"
                icon="pi pi-check-circle"
                iconPos="right"
                styleClass="width-100 p-button-success p-button-text p-button-rounded"
                label="Finalizar as peças em andamento"
                [disabled]="checkDataSelectionParaFinalizar(element.id)"
                (onClick)="onFinalizarEtapa()"
              ></p-button>
              <p-button
                *ngIf="
                  validActionsPedidos.concluir_multiplas_pecas &&
                  !isOnlyMonitoramento
                "
                icon="pi pi-thumbs-up"
                iconPos="right"
                styleClass="width-100 p-button-success p-button-text p-button-rounded"
                label="Concluir as peças do pedido"
                [disabled]="checkDataSelectionFinalizados(element.id)"
                (onClick)="onConclusion()"
              ></p-button>
              <p-button
                *ngIf="
                  validActionsPedidos.concluir_pedido && !isOnlyMonitoramento
                "
                iconPos="right"
                icon="pi pi-thumbs-up"
                styleClass="width-100 p-button-success p-button-text p-button-rounded"
                label="Concluir pedido"
                [disabled]="
                  element.status !== 'CONCLUIDO_PARTES' ||
                  !element.is_processo_finalizado ||
                  statusProcesso !== 'FINALIZADO' ||
                  statusPedido !== 'CONCLUIDO_PARTES'
                "
                (onClick)="onSendPedidoConcluido.emit([element])"
              ></p-button>
              <p-button
                icon="pi pi-images"
                iconPos="right"
                styleClass="width-100 p-button-primary p-button-text p-button-rounded"
                label="Visualizar imagens"
                [disabled]="element.imagens.length === 0"
                (onClick)="openDialogImgs(element.imagens)"
              ></p-button>
              <p-button
                icon="pi pi-print"
                iconPos="right"
                styleClass="width-100 p-button-primary p-button-text p-button-rounded"
                label="Visualizar ficha técnica"
                [disabled]="!element.ficha_tecnica_id"
                (onClick)="downloadFicha(element.ficha_tecnica_id)"
              ></p-button>
              <p-button
                icon="pi pi-eye"
                iconPos="right"
                styleClass="width-100 p-button-primary p-button-text p-button-rounded"
                label="Detalhes do pedido"
                [disabled]="!element"
                (onClick)="openDetalhesPedido(element)"
              ></p-button>
            </div>
          </mat-menu>
        </div>
        <div
          *ngIf="!col.useBtnAction"
          [class]="
            col.iconClass
              ? 'flex align-items-center justify-content-center width-100'
              : ''
          "
          [pTooltip]="col.iconToolTip ? col.iconToolTip(element) : null"
          [pRowToggler]="
            processo && !processo.gerencia_partes
              ? null
              : element.isSelected || col.useBtnAction
              ? null
              : element
          "
        >
          <span class="p-column-title">{{ col.header_name }}</span>
          {{
            col.cellRenderer ? col.cellRenderer(element) : element[col.field]
          }}
          <i *ngIf="col.iconClass" [class]="col.iconClass(element)"></i>
        </div>
      </td>
      <td
        [ngClass]="{ 'bg-black-alpha-30': expanded }"
        style="width: 3rem"
        [pRowToggler]="
          (processo && !processo.gerencia_partes) || element.isSelected
            ? null
            : element
        "
      ></td>
    </tr>
  </ng-template>
  <ng-template pTemplate="rowexpansion" let-element>
    <tr>
      <td colspan="14">
        <div class="p-2">
          <p-table
            #dt2
            [value]="entitiesExpandedData"
            [(selection)]="dataSelectionPartes"
            selectionMode="multiple"
            [rowHover]="true"
            [paginator]="true"
            [rowsPerPageOptions]="[5, 10, 15]"
            [rows]="5"
            (onRowSelect)="onRowSelect($event)"
          >
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 3rem" *ngIf="showBtnActionsPartes">
                  <mat-checkbox
                    [checked]="
                      dataSelectionPartes.length !== 0
                        ? dataSelectionPartes.length ===
                          entitiesExpandedData.length
                        : false
                    "
                    color="primary"
                    [indeterminate]="
                      dataSelectionPartes.length !== 0
                        ? dataSelectionPartes.length !==
                          entitiesExpandedData.length
                        : false
                    "
                    (change)="
                      $event.checked
                        ? (dataSelectionPartes = entitiesExpandedData)
                        : (dataSelectionPartes = [])
                    "
                  ></mat-checkbox>
                </th>
                <th
                  *ngFor="let col of columnsExpanded"
                  pResizableColumn
                  [pSortableColumn]="col.sortable ? col.field_sortable : null"
                >
                  {{ col.header_name }}
                </th>
                <th style="width: 3rem">
                  <button
                    pButton
                    pRipple
                    icon="pi pi-fw pi-cog"
                    severity="info"
                    rounded
                    text
                    (click)="openDialogReorderColumns(true)"
                    pTooltip="Organizar colunas da tabela"
                  ></button>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-parte let-rowIndex="rowIndex">
              <!-- [ngClass]="{
                'item-etapa': true,
                'item-etapa-concluida': parte.status === 'CONCLUIDO',
                'item-etapa-finalizada':
                  parte.status !== 'CONCLUIDO' && parte.is_etapa_finalizada,
                'item-etapa-erro': parte.has_erro_pendente
              }" -->
              <tr
                [ngClass]="{ 'item-etapa': true }"
                [style]="
                  parte.etapa
                    ? '--etapa-color:' + parte.etapa.color
                    : '--etapa-color: #324581'
                "
              >
                <td *ngIf="showBtnActionsPartes">
                  <p-tableCheckbox
                    [disabled]="
                      dataSelectionPartes.length
                        ? dataSelectionPartes[0].pedido_id !== element.id
                        : false
                    "
                    [value]="parte"
                  ></p-tableCheckbox>
                </td>
                <td *ngFor="let col of columnsExpanded">
                  <div
                    *ngIf="col.isAction && !col.useBtnAction"
                    [pSelectableRow]="
                      dataSelectionPartes.length
                        ? dataSelectionPartes[0].pedido_id === element.id
                          ? parte
                          : []
                        : parte
                    "
                    [pSelectableRowIndex]="
                      dataSelectionPartes.length
                        ? dataSelectionPartes[0].pedido_id === element.id
                          ? rowIndex
                          : []
                        : rowIndex
                    "
                  >
                    <p-button
                      [disabled]="
                        col.disableActionInfo
                          ? col.disableActionInfo(parte)
                          : false
                      "
                      [pTooltip]="
                        col.iconToolTip ? col.iconToolTip(parte) : null
                      "
                      (onClick)="
                        col.field === 'servicos'
                          ? showServicos(parte.servicos)
                          : showAdicionais(parte.adicionais)
                      "
                      icon="pi pi-fw pi-eye"
                      [label]="
                        col.field === 'servicos'
                          ? parte.servicos.length
                          : parte.adicionais.length
                      "
                      iconPos="right"
                      styleClass="p-button-primary p-button-text p-button-rounded"
                    ></p-button>
                  </div>

                  <div
                    *ngIf="!col.useBtnAction && !col.isAction"
                    [class]="
                      col.iconClass
                        ? 'flex align-items-center justify-content-center width-100'
                        : ''
                    "
                    [pTooltip]="col.iconToolTip ? col.iconToolTip(parte) : null"
                    [pSelectableRow]="
                      dataSelectionPartes.length
                        ? dataSelectionPartes[0].pedido_id === element.id
                          ? parte
                          : []
                        : parte
                    "
                    [pSelectableRowIndex]="
                      dataSelectionPartes.length
                        ? dataSelectionPartes[0].pedido_id === element.id
                          ? rowIndex
                          : []
                        : rowIndex
                    "
                  >
                    {{
                      col.cellRenderer
                        ? col.cellRenderer(parte)
                        : parte[col.field]
                    }}
                    <i *ngIf="col.iconClass" [class]="col.iconClass(parte)"></i>
                  </div>
                  <div *ngIf="col.useBtnAction && !col.isAction">
                    <p-button
                      outlined
                      rounded
                      icon="pi pi-ellipsis-v"
                      styleClass="p-button-primary p-button-text p-button-rounded"
                      pTooltip="Ações nas peças"
                      [disabled]="parte.status === 'CONCLUIDO'"
                      [matMenuTriggerFor]="
                        parte.status === 'CONCLUIDO' ? null : menuAcoesPartes
                      "
                    ></p-button>
                    <mat-menu #menuAcoesPartes="matMenu">
                      <div
                        class="flex flex-column justify-content-center width-100"
                      >
                        <p-button
                          *ngIf="validActionsPartes.iniciar_producao"
                          icon="pi pi-play-circle"
                          iconPos="right"
                          styleClass="width-100 p-button-help p-button-text p-button-rounded"
                          label="Iniciar produção"
                          (onClick)="onStartParte.emit([parte])"
                          [disabled]="
                            parte.is_etapa_iniciada ||
                            statusParte !== 'AGUARDANDO' ||
                            !etapa
                          "
                        ></p-button>
                        <p-button
                          *ngIf="validActionsPartes.etapa_seguinte"
                          icon="pi pi-send"
                          iconPos="right"
                          styleClass="width-100 p-button-primary p-button-text p-button-rounded"
                          label="Definir etapa"
                          (onClick)="onEnviarParaEtapa.emit([parte])"
                          [disabled]="
                            statusParte !== 'FINALIZADO' ||
                            statusPedido !== 'EM_ANDAMENTO' ||
                            statusProcesso !== 'EM_ANDAMENTO' ||
                            !etapa ||
                            !parte.is_etapa_iniciada ||
                            (!parte.is_etapa_finalizada &&
                              parte.etapas.length !== 0) ||
                            parte.has_erro_pendente ||
                            parte.status === 'CONCLUIDO'
                          "
                        ></p-button>
                        <p-button
                          *ngIf="validActionsPartes.etapa_erro"
                          icon="pi pi-exclamation-triangle"
                          iconPos="right"
                          styleClass="width-100 p-button-danger p-button-text p-button-rounded"
                          [label]="
                            parte.has_erro_pendente
                              ? 'Visualizar Erro'
                              : 'Cadastrar erro'
                          "
                          (onClick)="onGenerateError.emit({ peca: parte })"
                          [disabled]="
                            !parte.is_etapa_iniciada ||
                            parte.is_etapa_finalizada ||
                            parte.status === 'CONCLUIDO' ||
                            parte.etapas.length === 0
                          "
                        ></p-button>
                        <p-button
                          *ngIf="validActionsPartes.etapa_finalizar"
                          icon="pi pi-check-circle"
                          iconPos="right"
                          styleClass="width-100 p-button-success p-button-text p-button-rounded"
                          label="Finalizar a parte em andamento"
                          [disabled]="
                            !parte.is_etapa_iniciada ||
                            parte.is_etapa_finalizada ||
                            parte.has_erro_pendente ||
                            statusParte !== 'PRODUZINDO' ||
                            statusPedido !== 'EM_ANDAMENTO' ||
                            statusProcesso !== 'EM_ANDAMENTO' ||
                            !etapa ||
                            parte.etapas.length === 0
                          "
                          (onClick)="onGenerateFinalizarEtapa.emit([parte])"
                        ></p-button>
                        <p-button
                          *ngIf="validActionsPartes.concluir_peca"
                          icon="pi pi-thumbs-up"
                          iconPos="right"
                          styleClass="width-100 p-button-success p-button-text p-button-rounded"
                          label="Concluir a peça"
                          [disabled]="
                            !parte.is_etapa_iniciada ||
                            !parte.is_etapa_finalizada ||
                            parte.has_erro_pendente ||
                            parte.status === 'CONCLUIDO' ||
                            statusParte !== 'FINALIZADO' ||
                            statusPedido !== 'EM_ANDAMENTO' ||
                            statusProcesso !== 'EM_ANDAMENTO' ||
                            !etapa ||
                            parte.etapas.length === 0
                          "
                          (onClick)="onGenerateConclusion.emit([parte])"
                        ></p-button>
                        <p-button
                          *ngIf="validActionsPartes.etapa_anterior"
                          icon="pi pi-arrow-circle-left"
                          iconPos="right"
                          styleClass="width-100 p-button-danger p-button-text p-button-rounded"
                          label="Encaminhar para etapa anterior"
                          (onClick)="onEnviarParaEtapaAnterior.emit(parte)"
                          [disabled]="
                            !parte.is_etapa_iniciada ||
                            !parte.is_etapa_finalizada ||
                            checkEtapasVoltadas(parte.etapas) ||
                            parte.has_erro_pendente ||
                            parte.status === 'CONCLUIDO'
                          "
                        ></p-button>
                      </div>
                    </mat-menu>
                  </div>
                </td>
                <td
                  style="width: 3rem"
                  [pSelectableRow]="
                    dataSelectionPartes.length
                      ? dataSelectionPartes[0].pedido_id === element.id
                        ? parte
                        : []
                      : parte
                  "
                  [pSelectableRowIndex]="
                    dataSelectionPartes.length
                      ? dataSelectionPartes[0].pedido_id === element.id
                        ? rowIndex
                        : []
                      : rowIndex
                  "
                ></td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="14">
                  <p-progressSpinner
                    ariaLabel="loading"
                    *ngIf="loadingExpandedData"
                  ></p-progressSpinner>
                  <h4
                    class="text-center font-weight-light d-flex justify-content-center mt-3"
                    *ngIf="
                      isEmptyExpandedData &&
                      !loadingExpandedData &&
                      !showErrorMessageExpandedData
                    "
                  >
                    Nenhuma peça cadastrada para esse pedido!
                  </h4>
                  <viggo-core-error
                    *ngIf="showErrorMessageExpandedData && !loadingExpandedData"
                    [title]="errorTitleExpandedData"
                    [srcImg]="errorImgSrcExpandedData"
                    [classImg]="'content-img'"
                    [noBackground]="true"
                    [message]="errorMessageExpandedData"
                  ></viggo-core-error>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="summary">
    <p-paginator
      (onPageChange)="handlePage($event)"
      [rowsPerPageOptions]="pageSizeOptions"
      [first]="first"
      [rows]="paginatorPageSize"
      [totalRecords]="pageLength"
    ></p-paginator>

    <div class="flex align-items-center width-100 justify-content-between">
      <span><b>Total de pedidos:</b> {{ pageLength }}</span>
      <span *ngIf="filterByEtapa" class="ml-3">
        <b>Total (peças/quantidade):</b> {{ totalPedidos }}/{{ totalPartes }}
      </span>
      <span *ngIf="filterByProcesso && !filterByEtapa" class="ml-3">
        <b>Quantidade de produtos:</b> {{ quantidadeProdutos }}
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td [colSpan]="columns.length + 4">
        <p-progressSpinner
          ariaLabel="loading"
          *ngIf="loading"
        ></p-progressSpinner>
        <h4
          class="text-center font-weight-light d-flex justify-content-center mt-3"
          *ngIf="isEmpty && !loading && !showErrorMessage"
        >
          Nenhum pedido foi encontrado!
        </h4>
        <viggo-core-error
          *ngIf="showErrorMessage && !loading"
          [title]="errorTitle"
          [srcImg]="errorImgSrc"
          [classImg]="'content-img'"
          [noBackground]="true"
          [message]="errorMessage"
        ></viggo-core-error>
      </td>
    </tr>
  </ng-template>
</p-table>
